import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { TOUR_STEPS } from '../data/tourSteps';

const DONE_KEY = 'bodyup_tour_completed_v1';
const NEVER_KEY = 'bodyup_tour_never_show_v1';

const TourContext = createContext(null);

/** Tour guidé "Ultra-pro" Spotlight — état global (étape active) + persistance localStorage
 * de la complétion / "ne plus jamais afficher" (réversible depuis Profil). */
export const TourProvider = ({ children }) => {
  const [stepIndex, setStepIndex] = useState(-1);
  const active = stepIndex >= 0 && stepIndex < TOUR_STEPS.length;

  useEffect(() => {
    const neverShow = localStorage.getItem(NEVER_KEY) === '1';
    const completed = localStorage.getItem(DONE_KEY) === '1';
    if (!neverShow && !completed) {
      const t = setTimeout(() => setStepIndex(0), 1400);
      return () => clearTimeout(t);
    }
  }, []);

  const finish = useCallback((neverShow = false) => {
    setStepIndex(-1);
    localStorage.setItem(DONE_KEY, '1');
    if (neverShow) localStorage.setItem(NEVER_KEY, '1');
  }, []);

  const start = useCallback(() => setStepIndex(0), []);
  const next = useCallback(() => {
    setStepIndex((i) => (i + 1 >= TOUR_STEPS.length ? (finish(false), -1) : i + 1));
  }, [finish]);
  const prev = useCallback(() => setStepIndex((i) => Math.max(0, i - 1)), []);
  const skip = useCallback((neverShow) => finish(!!neverShow), [finish]);

  const isNeverShow = useCallback(() => localStorage.getItem(NEVER_KEY) === '1', []);
  const setNeverShow = useCallback((val) => {
    if (val) localStorage.setItem(NEVER_KEY, '1'); else localStorage.removeItem(NEVER_KEY);
  }, []);

  const value = {
    active, stepIndex, step: active ? TOUR_STEPS[stepIndex] : null, total: TOUR_STEPS.length,
    start, next, prev, skip, finish, isNeverShow, setNeverShow,
  };

  return <TourContext.Provider value={value}>{children}</TourContext.Provider>;
};

export const useTour = () => useContext(TourContext);
